export default "__VITE_ASSET__b7856c15__"